

































































































import Vue from 'vue';
import { Subscription } from 'rxjs';
import { authService } from '@/services/AuthService';
import { environmentService } from '@/services/EnvironmentService';
import { loadingService } from '@/services/LoadingService';

export default Vue.extend({
  name: 'Header',

  data: () => ({
    loading: false,
    showSettings: false,
    drawer: false,
    title: environmentService.appTitle,
    isUserLoggedIn: false,
    authChangedSubscription: new Subscription(),
    loadingStateChangedSubscription: new Subscription()
  }),

  methods: {
    logout(): void {
      authService.logout();
    }
  },

  mounted(): void {
    this.isUserLoggedIn = authService.isUserLoggedIn;
    this.authChangedSubscription = authService.authChanged.subscribe(authStatus => (this.isUserLoggedIn = authStatus));
    this.loadingStateChangedSubscription = loadingService.loadingStateChanged.subscribe(
      loading => (this.loading = loading)
    );
  },

  beforeDestroy(): void {
    this.authChangedSubscription.unsubscribe();
    this.loadingStateChangedSubscription.unsubscribe();
  }
});
